/** Autopilot rule management. */
import { endpoints } from '@/config/env';
import type { AutopilotAuditEntry, AutopilotRule, AutopilotRuleInput, Page } from '@/types';
import { request } from './client';

export function fetchAutopilotRules(signal?: AbortSignal): Promise<AutopilotRule[] | null> {
  return request<AutopilotRule[] | null>(endpoints.autopilotRules(), { signal });
}

export function fetchAutopilotAudit(
  page = 0,
  size = 20,
  signal?: AbortSignal,
): Promise<Page<AutopilotAuditEntry> | null> {
  return request<Page<AutopilotAuditEntry> | null>(endpoints.autopilotAudit(page, size), { signal });
}

export function createAutopilotRule(input: AutopilotRuleInput): Promise<AutopilotRule | null> {
  return request<AutopilotRule | null>(endpoints.autopilotRules(), { method: 'POST', body: input });
}

export function updateAutopilotRule(
  ruleId: string,
  input: Partial<AutopilotRuleInput>,
): Promise<AutopilotRule | null> {
  return request<AutopilotRule | null>(endpoints.autopilotRule(ruleId), { method: 'PUT', body: input });
}

export function deleteAutopilotRule(ruleId: string): Promise<null> {
  return request<null>(endpoints.autopilotRule(ruleId), { method: 'DELETE' });
}
